import React, { useEffect } from 'react';
import style from './index.module.scss';

export default function SmallToast({ toastText = '' }) {
	useEffect(() => {
		const toaster = document.getElementById('toast');

		if (!toaster) {
			return;
		}

		toaster.classList.toggle(style.show);

		const timer = setTimeout(() => {
			toaster.classList.remove(style.show);
		}, 3000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div id="toast" className={'smallToastContainer ' + style.toast}>
			{toastText}
		</div>
	);
}
